import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import type { GameLinkView } from '#src/interfaces/gameManager'
import { getGameDisplayName, getGameThumbnail, getGameUrls } from '#src/utils/gameUtils'

export const useGame = (gameLinkInput: MaybeRefOrGetter<GameLinkView | undefined>) => {
  const gameLink = computed(() => toValue(gameLinkInput))
  const game = computed(() => gameLink.value?.installation.game)
  const gameId = computed(() => game.value?.id)
  const urls = computed(() => (game.value ? getGameUrls(game.value) : undefined))
  const ssbtUrl = computed(() => urls.value?.ssbtUrl)
  const posUrl = computed(() => urls.value?.posUrl)

  const linkCode = computed(() => gameLink.value?.code)
  const gameDisplayId = computed(() => game.value?.displayId)
  const gameDisplayName = computed(() =>
    gameLink.value ? getGameDisplayName(gameLink.value) : undefined
  )

  const thumbnail = computed(() => (game.value ? getGameThumbnail(game.value) : undefined))

  return {
    game,
    gameId,
    linkCode,
    gameDisplayId,
    gameDisplayName,
    thumbnail,
    ssbtUrl,
    posUrl
  }
}
